module.exports = __webpack_public_path__ + "static/img/wechat-xcx.5bf1dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/download/wechat-xcx.jpg
// module id = 3Cy8
// module chunks = 0